import Api from "../apiService";

class TableConfigsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/table_configs`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/table_configs/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/table_configs`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/table_configs/${id}`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/table_configs/${id}`,
      {},
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/table_configs/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/table_configs/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  reset(companyId, id) {
    return Api.postRequest(
      `companies/${companyId}/table_configs/${id}/reset_to_default`,
      {},
      Api.authHeaders()
    );
  }

  setCurrent(companyId, id) {
    return Api.postRequest(
      `companies/${companyId}/table_configs/${id}/set_current`,
      {},
      Api.authHeaders()
    );
  }

  getFields(companyId, configId) {
    return Api.getRequest(
      `companies/${companyId}/table_configs/${configId}/table_field_configs`,
      {},
      Api.authHeaders()
    );
  }

  createField(companyId, configId, data) {
    return Api.postRequest(
      `companies/${companyId}/table_configs/${configId}/table_field_configs`,
      data,
      Api.authHeaders()
    );
  }

  updateField(companyId, configId, fieldId, data) {
    return Api.patchRequest(
      `companies/${companyId}/table_configs/${configId}/table_field_configs/${fieldId}`,
      data,
      Api.authHeaders()
    );
  }

  enableField(companyId, configId, fieldId) {
    return Api.patchRequest(
      `companies/${companyId}/table_configs/${configId}/table_field_configs/${fieldId}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disableField(companyId, configId, fieldId) {
    return Api.patchRequest(
      `companies/${companyId}/table_configs/${configId}/table_field_configs/${fieldId}/disable`,
      {},
      Api.authHeaders()
    );
  }

  deleteField(companyId, configId, fieldId) {
    return Api.deleteRequest(
      `companies/${companyId}/table_configs/${configId}/table_field_configs/${fieldId}`,
      {},
      Api.authHeaders()
    );
  }
}

export default new TableConfigsApi();
